<script lang="ts" setup>
import { computed } from 'vue'

import { priorities } from '@/utils/constants'

const props = withDefaults(
  defineProps<{
    selectedPriorities: number[]
    dense?: boolean
    mandatory?: boolean
  }>(),
  {
    dense: true,
    mandatory: false,
  },
)

const emit = defineEmits<(e: 'on-change', priorities: number[]) => void>()

const selected = computed({
  get() {
    return props.selectedPriorities ?? []
  },
  set(newArray: number[]) {
    emit('on-change', newArray)
  },
})
</script>

<template>
  <v-btn-toggle
    v-model="selected"
    :dense="dense"
    :mandatory="mandatory"
    color="blue"
    multiple
    rounded
  >
    <v-btn
      v-for="priority in priorities"
      :key="priority.id"
      :data-test="`priority-${priority.name}`"
      :max-height="34"
      :min-width="0"
      :value="priority.id"
      text
    >
      <v-tooltip bottom>
        <template #activator="{ on }">
          <v-icon :color="priority.color" :size="20" v-on="on">
            {{ priority.icon }}
          </v-icon>
        </template>

        <span>{{ priority.name }}</span>
      </v-tooltip>
    </v-btn>
  </v-btn-toggle>
</template>
